module.exports = __webpack_public_path__ + "img/eLearning.81b45da.jpg";